import { Outlet } from "react-router";

const Popup = () => {
  // popup 속성을 통해 연 창만 팝업으로 인식
  if (!(opener && window.name.includes("Popup"))) throw new Error();
  return <Outlet />;
};

export default Popup;
